import React, { useState } from "react"
import { Container, Row, Col, Form, Label, FormGroup, Input, Button } from "reactstrap"
import "./app.css"
import doggo from "../assets/IMG_3606.JPG"
import breakline from "../assets/break.PNG";
import invisiBreak from "../assets/pattern-3.svg"
import modernTeaRoom from "../assets/modernTeaRoom.JPG"
import TileContainer from "../containers/TitleContainer"
import { firestore } from "../firebase";
import moment from "moment";
import { toUtcDateOnly } from "../utils/dateUtils";

const BookingForm = (props) => {

    const [title, setTitle] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [tel, setTel] = useState("");
    const [email, setEmail] = useState();
    const [address, setAddress] = useState();
    const [postcode, setPostcode] = useState();
    const [additionalAdults, setAdditionalAdults] = useState(0);
    const [additionalChildren, setAdditionalChild] = useState(0);
    const [singleOccupancy, setSingleOccupancy] = useState(false);
    const [travelCotRequired, setTravelCotRequired] = useState(false)
    const [successfullyBooked, setSuccessfullyBooked] = useState(false)
    const [additionalInfo, setAdditionalInfo] = useState("")
    const bookingState = props.location && props.location.state ? props.location.state : null;

    const onChangeHandler = (event) => {
        const { name, value } = event.currentTarget;

        if (name === 'title') {
            setTitle(value);
        }
        else if (name === "firstName") {
            setFirstName(value);
        }
        else if (name === "lastName") {
            setLastName(value);
        }
        else if (name === "tel") {
            setTel(value);
        }
        else if (name === "email") {
            setEmail(value);
        }
        else if (name === "address") {
            setAddress(value)
        }
        else if (name === "postcode") {
            setPostcode(value)
        }
        else if (name === "additionalAdults")
        {
            setAdditionalAdults(value)
        }
        else if (name === "additionalChildren"){
            setAdditionalChild(value)
        }
        else if (name === "travelCotRequired"){
            setTravelCotRequired(value)
        }
        else if (name === "additionalInfo"){
            setAdditionalInfo(value)
        }
    }

    const getDateWithoutTime = (dateWithTime) => {
        const formatted = moment(new Date(dateWithTime)).format("Do MMMM YYYY");
        console.log(`[BookingForm.getDateWithoutTime] raw: ${dateWithTime} -> formatted: ${formatted}`);
        return formatted;
        //new Date(dateWithTime.getFullYear(), dateWithTime.getMonth(), dateWithTime.getDate())

    }

    const createBooking = () => {
        if (!bookingState) {
            alert("Please check availability on the Accommodation page first.")
            return;
        }

        if(tel.length < 1){
            alert("Please enter your mobile number")
            return;
        }
        var roomCollection = bookingState.room.replace(/ /g, '').toLowerCase()
        console.log(roomCollection)
        firestore.collection("tempBooking" + roomCollection).add({
            RoomName: roomCollection,
            bookedFrom: toUtcDateOnly(bookingState.bookFrom),
            numberOfNights: bookingState.numberOfNights,
            bringingDogs: bookingState.bringingDogs,
            singleOccupancy: bookingState.singleOccupancy,
            title: title,
            firstName: firstName,
            lastName: lastName,
            tel: tel,
            email: email,
            address: address,
            postcode: postcode,
            additionalAdults: additionalAdults,
            additionalChildren: additionalChildren,
            travelCotRequired: travelCotRequired,
            singleOccupancy: singleOccupancy,
            createDateTime: new Date(),
            additionalInfo: additionalInfo
        }).then(() => {
            setSuccessfullyBooked(true)
        });
    }

    const getDogsAsYesNo = (e) => {
        if(e)
        {
            return "Yes"
        }
        else{
            return "No"
        }
    }

    const displayAccommodationBookingInfo = () => {
        return (
            <Row className="row-m-20">
                <Col className="col-m-b-20 remove-padding">
                    <div className="textContainer">
                        <h3 style={{ marginBottom: 12 }}>Accommodation</h3>
                        <p>We have 8 bedrooms available.</p>
                        <p><b>Prices per night:</b></p>
                        <ul>
                            <li>Standard Double £65</li>
                            <li>Single Occupancy £60</li>
                            <li>Superior Double Room £85</li>
                            <li>Additional beds £15 per guest</li>
                        </ul>
                        <p><b>Room features:</b></p>
                        <ul>
                            <li>All have ensuite with shower</li>
                            <li>Free WiFi</li>
                            <li>24 hour keycode entry (check in with us during tearoom opening hours, or we text your keycode)</li>
                            <li>Central to local car parks and free on-street parking</li>
                            <li>Breakfast included (GF and Vegan options available)</li>
                            <li>Dogs welcome, with designated dog-free rooms also available</li>
                        </ul>
                    </div>
                </Col>
            </Row>
        )
    }

    const displayBookingForm = () => {
        if(successfullyBooked)
        {
            return(
                <Row className="row-m-20">
                    <Col className="col-m-b-20 remove-padding">
                    <div className="textContainer">
                    Thank you for your booking enquiry. We will be in touch within 24 hours to confirm your booking and to complete payment.
                        </div>
                    </Col>
                </Row>
            )
            
        }else{
            if (!bookingState) {
                return(
                    <div>
                        {displayAccommodationBookingInfo()}
                        <Row className="row-m-20">
                            <Col className="col-m-b-20 remove-padding">
                                <div className="textContainer" style={{ fontWeight: 700 }}>
                                    <h3 style={{ marginBottom: 12 }}>To book</h3>
                                    <p>Please call <b>01538 372122</b> (8:30 - 2:30, 7 days a week) or leave a message outside these hours.</p>
                                    <p>Email us at <a href="mailto:info@whiteharttearoom.co.uk" style={{color:"black"}}>info@whiteharttearoom.co.uk</a>.</p>
                                    <p>Or complete the online enquiry form via the accommodation booking flow.</p>
                                    <p><a href="/accommodation" style={{color:"black"}}>Go to Accommodation</a></p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                )
            }

            return(
                <div>
                    {displayAccommodationBookingInfo()}
                    <Row className="row-m-20">
                <Col className="textContainer booking-help-panel" style={{ fontWeight: 700 }}>
                    <h3 style={{ marginBottom: 12 }}>To book</h3>
                    <p>Please call <b>01538 372122</b> (8:30 - 2:30, 7 days a week), or leave a message outside these hours.</p>
                    <p>Email us at <a href="mailto:info@whiteharttearoom.co.uk" style={{color:"black"}}>info@whiteharttearoom.co.uk</a>.</p>
                    <p>Or complete the online enquiry form below.</p>
                    <p style={{ marginBottom: 0 }}><i>Please note that it may take us a couple of days to reply to form enquiries.</i></p>
                </Col>
            </Row>
            <Row className="row-m-20">
                <Col className="textContainer booking-form-heading">
                    <b>Online Enquiry Form</b>
                    <p style={{ marginTop: 10, marginBottom: 0 }}>Please fill in all fields. We will contact you via telephone to complete the booking and take payment.</p>
                </Col>
            </Row>
            <Row className="row-m-20">
                <Col className="col-m-b-20 remove-padding">
                    <div className="textContainer">
                        <Form>
                            <Row>
                            <Col>Please ensure that all fields are filled</Col>
                            </Row>
                            <Row form className="row-m-20">
                                <Col md={3}>
                                    <Label for="checkInDate">Check In Date</Label>
                                    <Input type="text" name="checkInDate" id="checkInDate" disabled={true} value={getDateWithoutTime(bookingState.bookFrom)} />
                                </Col>
                                <Col md={3}>
                                    <Label for="nights">Number Of Nights</Label>
                                    <Input type="text" id="nights" name="nights" disabled={true} value={bookingState.numberOfNights} />
                                </Col>
                                <Col md={3}>
                                    <Label for="dogs">Dogs</Label>
                                    <Input type="text" id="dogs" name="dogs" disabled={true} value={getDogsAsYesNo(bookingState.bringingDogs)} />
                                </Col>
                                <Col md={3}>
                                    <Label for="room">Room</Label>
                                    <Input type="text" id="room" name="room" disabled={true} value={bookingState.room} />
                                </Col>
                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="additionalAdults">Additional Adults</Label>
                                        <Input onChange={(event) => onChangeHandler(event)} type="select" name="additionalAdults" id="additionalAdults">
                                            <option value="0">0</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="additionalChildren">Additional Children</Label>
                                        <Input onChange={(event) => onChangeHandler(event)} type="select" name="additionalChildren" id="additionalChildren">
                                            <option value="0">0</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="travelCotRequired">Travelcot Required</Label>
                                        <Input onChange={(event) => onChangeHandler(event)} type="select" name="travelCotRequired" id="travelCotRequired">
                                            <option value="false">No</option>
                                            <option value="true">Yes</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="title">Title</Label>
                                        <Input onChange={(event) => onChangeHandler(event)} type="select" name="title" id="title">
                                            <option value=""></option>
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Miss">Miss</option>
                                            <option value="Ms">Ms</option>
                                            <option value="Mx">Mx</option>
                                            <opion value="Other">Other</opion>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="firstName">First Name</Label>
                                        <Input onChange={(event) => onChangeHandler(event)} type="text" name="firstName" id="firstName" />
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="lastName">Last Name</Label>
                                        <Input onChange={(event) => onChangeHandler(event)} type="text" name="lastName" id="lastName" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="tel">Mobile Number</Label>
                                        <Input onChange={(event) => onChangeHandler(event)} type="text" name="tel" id="tel" />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="email">Email</Label>
                                        <Input onChange={(event) => onChangeHandler(event)} type="text" name="email" id="email" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="address">Address</Label>
                                        <Input onChange={(event) => onChangeHandler(event)} type="textarea" rows={6} name="address" id="address" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="postcode">Postcode</Label>
                                        <Input onChange={(event) => onChangeHandler(event)} type="text" name="postcode" id="postcode" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="additionalInfo">Additional Information</Label>
                                        <Input type="textarea" name="additionalInfo" rows={5} onChange={(event) => onChangeHandler(event)}/>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form className="row-m-20">
                                <Col>
                                    <FormGroup>
                                        <Button onClick={(e) => createBooking(e)}>Book Now</Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form>
                                <Col>
                                    <p style={{ marginTop: 10, marginBottom: 0, fontWeight: 700 }}>
                                        PLEASE NOTE IF YOU USE THIS FORM IT MAY TAKE US A FEW DAYS TO GET BACK TO YOU
                                    </p>
                                </Col>
                            </Row>
                        </Form>
                                    <Col>Please ensure that all fields are filled</Col>

                    </div>
                </Col>
            </Row>
                </div>
            )
        }
    }

    return (

        <Container fluid>

            <Container fluid>
                <TileContainer title={"Accommodation Booking"} />
            </Container>
            <div>
                {displayBookingForm()}
            </div>
        </Container>
    )
}

export default BookingForm